import { Inject, Injectable } from '@angular/core';
import { AumicoCoreConfig, AumicoCoreConfigService } from '../aumico-core.config';

@Injectable({
    providedIn: 'root',
})
export class RoutesUtil {
    private readonly locales = 'locales';
    private readonly configurations = 'configurations';
    private readonly announcements = 'announcements';
    private readonly active = 'active';
    private readonly route = '/';
    private readonly server: string;
    private readonly surveys = 'surveys';
    private readonly status = 'status';
    private readonly response = 'response';
    private readonly responses = 'responses';
    private readonly export = 'export';
    private readonly notifications = 'notifications';
    private readonly notification = 'notification';
    private readonly user = 'users';
    private readonly eligibleUsers = 'eligible-users';

    constructor(@Inject(AumicoCoreConfigService) private readonly config: AumicoCoreConfig) {
        this.server = this.config.apiGateway;
    }

    public getSupportedLocales(): string {
        return `${this.server}${this.configurations}${this.route}${this.locales}`;
    }

    public buildAnnouncementsUrl(): string {
        return `${this.server}${this.announcements}`;
    }

    public buildAnnouncementByIdUrl(id: string): string {
        return `${this.server}${this.announcements}${this.route}${id}`;
    }

    public buildUserAnnouncementsUrl(): string {
        return `${this.server}${this.user}${this.route}me${this.route}${this.announcements}`;
    }

    public buildDismissAnnouncementUrl(announcementId: string): string {
        return `${this.server}${this.user}${this.route}me${this.route}${this.announcements}${this.route}${announcementId}${this.route}dismiss`;
    }

    public createSurvey(): string {
        return `${this.server}${this.surveys}`;
    }

    public getActiveSurveyRoute(): string {
        return `${this.server}${this.surveys}${this.route}${this.active}`;
    }

    public stopSurveyRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}`;
    }

    public downloadSurveyRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}${this.route}${this.export}`;
    }

    public deleteSurveyRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}`;
    }

    public getCheckUserEligibilityRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}`;
    }

    public getSaveResponseRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}${this.route}${this.response}`;
    }

    public getUpdateUserSurveyStatusRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}${this.route}${this.status}`;
    }

    public getGetUserSurveyStatusRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}${this.route}${this.status}`;
    }

    public getGetUsersToNotifyRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}${this.route}${this.notification}`;
    }

    public getMarkUserAsNotifiedRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}${this.route}${this.notification}`;
    }

    public getSurveyByIdRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}`;
    }

    public getSurveyResponsesRoute(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}${this.route}${this.responses}`;
    }

    public getAllSurveysRoute(): string {
        return `${this.server}${this.surveys}`;
    }

    public getEligibleUsersSurveyStatus(id: string): string {
        return `${this.server}${this.surveys}${this.route}${id}${this.route}${this.eligibleUsers}`;
    }

    public buildUserNotificationsUrl(): string {
        return `${this.server}${this.notifications}`;
    }
}
